const muiSnackbar = (theme) => {
  theme.overrides.MuiSnackbar = {
    root: {
      position: 'fixed',
      right: '20px !important',
      left: 'unset',
      width: '100%',
      maxWidth: 280,
      borderRadius: '5px !important',
    },
  };
};

export default muiSnackbar;
